import ConfigProvider, { ConfigContext, ConfigConsumer, useConfig, defaultConfig } from './configProvider'

export { ConfigContext, ConfigConsumer, useConfig, defaultConfig }

export default ConfigProvider
